import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;
export const RestroUsers = {
getAll: async ({
  tenantName,
  tenantCode,
  IsActive,
  RegisteredDateFrom,
  RegisteredDateTo,
  ValidDateFrom,
  ValidDateTo
}) => {
  const params = new URLSearchParams();
  if (tenantName) params.append("tenantName", tenantName);
  if (tenantCode) params.append("tenantCode", tenantCode);
  if (IsActive !== null && IsActive !== undefined) {
    params.append("IsActive", IsActive ? "true" : "false");
  }
  if (RegisteredDateFrom) params.append("RegisteredDateFrom", RegisteredDateFrom);
  if (RegisteredDateTo) params.append("RegisteredDateTo", RegisteredDateTo);
  if (ValidDateFrom) params.append("ValiTillFrom", ValidDateFrom);
  if (ValidDateTo) params.append("ValidTillTo", ValidDateTo);

  const queryString = params.toString();

  const response = await instance.get(`/restrousersinfo?${queryString}`);
  return response.data;
},

  getByApiKey: async(apiKey)=>{
     try{
      const response = await instance.get(`/restrousersinfo/apikey/${apiKey}`)
      return response.data;
    }catch(err){
      console.error(err)
      throw err;
    }
  },

  update: async (payload)=>{
    try{
      const response = await instance.put("/restrousersinfo", payload);
      return response.data
    }catch(err){
      console.error(err)
      throw err;
    }
  },
  
  Extend: async (payload)=>{
    try{
      const response = await instance.put("/restrousersinfo/extend-date", payload)
      return response.data
    }catch(err)
   {
    console.error(err)
   } 

  }

  }